import { useState } from 'react'
import { BaseGridLayout, BaseFeedbackConIcona } from '@lucan/base-ui'
import { OPERAZIONI, ROTTA_BACK_PAGOPA } from 'configuration/ConfigurazioneApi'
import { useVerbaliContext } from 'context/VerbaliProvider'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'

export default function useAvvioPagamento(props) {
  const { codiceAvviso, chiave } = props

  const { salvaChiaveVerbalePagamento } = useVerbaliContext()

  const [messaggio, setMessaggio] = useState()

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  async function avviaPagamento() {
    setMessaggio(null)
    salvaChiaveVerbalePagamento(chiave)
    const urlServer = window.location.origin + '/'
    const { ok, data } = await inviaOperazione(OPERAZIONI.PAGAMENTO_INIZIO, {
      chiave,
      codiceAvviso,
      backUrl: urlServer + ROTTA_BACK_PAGOPA,
      aurl: urlServer + ROTTA_BACK_PAGOPA,
    }, {},)

    const { respPaga, messaggio } = data
    if (ok && !messaggio) {
      window.location.href = respPaga.redirect
    }
    if (messaggio) {
      setMessaggio(messaggio)
    }
  }

  return {
    avviaPagamento,
    inAttesaPagamento: inAttesaDelServer,
    ScatolaMessaggiPagamento: (
      <BaseGridLayout alignCenter>
        {ScatolaMessaggi}
        {messaggio && <BaseFeedbackConIcona.Errore messaggio={messaggio} />}
      </BaseGridLayout>
    )
  }
}